import { computed, ref } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a6bbc8e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "btn-content flex-end"
};
const _hoisted_3 = {
  class: "btn-content"
};
const _hoisted_4 = {
  key: 0
};
import { useStore } from '@/store';
import { awaitWrap, OK, reportEvent } from '@/common';
import PaidAddModal from '@/views/paidDownloads/paidManage/components/PaidAddModal.vue';
import { queryPaidApp } from '@/api/paidApi';
export default /*#__PURE__*/_defineComponent({
  __name: 'PaidTableBlock',
  setup(__props, {
    expose
  }) {
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const columns = [{
      title: '产品名',
      dataIndex: 'appName',
      key: 'appName'
    }, {
      title: 'DBTID',
      dataIndex: 'dbtId',
      key: 'dbtId',
      width: 300
    }, {
      title: '工作室',
      dataIndex: 'studio',
      key: 'studio',
      width: 200
    }, {
      title: '主体/账号',
      dataIndex: 'mchName',
      key: 'mchName'
    }, {
      title: '渠道',
      dataIndex: 'chnlName',
      key: 'chnlName',
      width: 120
    }, {
      title: 'APPID',
      dataIndex: 'appid',
      key: 'appid',
      width: 120
    }];
    const tableLoading = ref(false);
    const visible = ref(false);
    const dataSource = ref([]); // 表格数据
    const pageIndex = ref(1); // 当前页
    const pageSize = ref(20); // 每页条数
    const pageTotal = ref(0); // 总条数
    const searchObj = ref({}); // 搜索条件
    const tableRef = ref(); // 表格ref
    const getData = async () => {
      let startTime = new Date().getTime();
      let params = {
        pageNum: pageIndex.value,
        pageSize: pageSize.value
      };
      Object.keys(searchObj.value).forEach(item => {
        if (searchObj.value[item] || searchObj.value[item] === 0) {
          params = {
            ...params,
            [item]: searchObj.value[item]
          };
        }
      });
      dataSource.value = [];
      tableLoading.value = true;
      const [err, data] = await awaitWrap(queryPaidApp(params));
      if (data && data.code === OK) {
        let res = (data === null || data === void 0 ? void 0 : data.data) || {
          list: [],
          total: 0
        };
        pageTotal.value = res === null || res === void 0 ? void 0 : res.total;
        dataSource.value = res.list;
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '付费产品管理',
            app_name: '',
            return_duration: (new Date().getTime() - startTime) / 1000,
            query_status: 'succeed'
          }
        });
      }
      if (err) {
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '付费产品管理',
            app_name: '',
            return_duration: (new Date().getTime() - startTime) / 1000,
            query_status: 'failed'
          }
        });
      }
      tableLoading.value = false;
    }; // 获取表格数据
    const searchData = async obj => {
      pageIndex.value = 1;
      searchObj.value = obj;
      await getData();
    }; // 搜索
    const changePage = async (page, pageS) => {
      pageIndex.value = page;
      pageSize.value = pageS;
      await getData();
    }; // 分页
    const addProduct = () => {
      visible.value = true;
    }; // 新增产品
    expose({
      searchData
    });
    return (_ctx, _cache) => {
      var _unref2;
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "primary",
        onClick: addProduct,
        class: "add-btn"
      }, {
        default: _withCtx(() => [_createTextVNode(" 新增 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: 'paidDownloads',
        permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
      }]])])]), _createVNode(_component_a_table, {
        bordered: "",
        columns: columns,
        "data-source": dataSource.value,
        "row-key": "id",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef,
        loading: tableLoading.value
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _record$config;
          return [column.dataIndex === 'appid' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString((_record$config = record.config) === null || _record$config === void 0 ? void 0 : _record$config.appId), 1)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["data-source", "loading"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => pageIndex.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        total: pageTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"]), _createVNode(PaidAddModal, {
        "modal-visible": visible.value,
        "onUpdate:modal-visible": _cache[2] || (_cache[2] = $event => visible.value = $event),
        onRefresh: getData
      }, null, 8, ["modal-visible"])]);
    };
  }
});